import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./MobileVerification.scss";
import { clientRoutes } from "../utils/routes";
import OtpStack from "./OtpStack";
import moment from "moment";
import { getIpAddress } from "../helpers/helpers.module";
import { Toast } from "../utils/toast";
import { Typography, Box } from "@mui/material";
import AuthApiServices from "../helpers/api/authApiServices";
import LoadingButton from "@mui/lab/LoadingButton";
import LayoutWithBackground from "./layout/LayoutWithBackground";
import SignUpLayout from "./layout/SignUpLayout";
import { useStyles } from "./styles";
import usePreventNavigationDuringLoading from "./PreventNavigation";
import { flushSync } from "react-dom";
import AnimatedDots from "./AnimatedDots";

export const getExpiryTime = () => {
  const expiry = localStorage.getItem("expiry");
  return new Date(expiry * 1000) - new Date();
};

const initialOtpValues = {
  "otp-1": "",
  "otp-2": "",
  "otp-3": "",
  "otp-4": "",
  "otp-5": "",
  "otp-6": "",
};

const NewDeviceVerification = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const expiryTime = getExpiryTime();
  const [inputValues, setInputValues] = useState(initialOtpValues);
  const [duration, setDuration] = useState(
    moment.duration(expiryTime, "millisecond"),
  );
  const [targetTime, setTargetTime] = useState(localStorage.getItem("expiry"));
  const [interval, setInterval] = useState(1000);
  const [state, setState] = useState({
    longitude: "",
    latitude: "",
    isResending: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  usePreventNavigationDuringLoading(loading);
  const phone = localStorage.getItem("keyword_method");
  const checkLocation = (value) => {
    if (value && value !== "") {
      return value;
    }
    return "0.0";
  };
  const setCoordinates = async () => {
    if (navigator.geolocation) {
      setState({ ...state, isLoading: true });
      navigator.geolocation.getCurrentPosition(
        (position) => {
          let lat = position.coords.latitude.toString() ?? "0.0";
          let long = position.coords.longitude.toString() ?? "0.0";

          setState({
            ...state,
            longitude: long,
            latitude: lat,
            isLoading: false,
          });
        },
        (err) => {
          console.log("We can't access your current geolocation!", err);
          Toast.warning(
            "We can't access your current geolocation, please enable your location services for best experience with us if your device supports the location services.",
          );
          setState({
            ...state,
            longitude: "0",
            latitude: "0",
            isLoading: false,
          });
        },
      );
    } else {
      setState({ ...state, latitude: "0.0", longitude: "0.0" });
    }
  };

  useEffect(() => {
    setCoordinates().then((r) => r);
  }, []);

  const handleSubmitOTP = async () => {
    const keys = Object.keys(inputValues);
    const otpValue = keys.map((el) => inputValues[el]).join("");
    setError("");

    if (otpValue.length !== 6 || !otpValue) {
      setError({
        message: "Please enter valid verification Keyword!",
      });
      return;
    }

    const values = {
      keyword: otpValue,
      ip_address: await getIpAddress(),
      hash_key: localStorage.getItem("hash_key"),
      session_key: localStorage.getItem("session_key"),
      longitude: checkLocation(state.longitude),
      latitude: checkLocation(state.latitude),
      ownership_uid: localStorage.getItem("ownership_uid"),
    };

    setLoading(true);
    try {
      // debugger;
      const res = await AuthApiServices.newDeviceMobileVerification(values);
      flushSync(() => setLoading(false));

      if (res?.data?.status === 1) {
        sessionStorage.setItem("login_hash_key", res.data.login_hash_key);
        navigate(clientRoutes.login);
      } else {
        Toast.error(res?.data?.message);
      }
    } catch (err) {
      Toast.error(
        "We encountered an issue while processing your login request. Please try again later.",
      );
      console.log("Something went wrong!", err);
    } finally {
      setLoading(false);
    }
  };

  const resendMobileVerification = async () => {
    setState({ ...state, isResending: true });
    const values = {
      ip_address: await getIpAddress(),
      latitude: checkLocation(state.latitude),
      longitude: checkLocation(state.longitude),
      hash_key: localStorage.getItem("hash_key"),
      ownership_uid: localStorage.getItem("ownership_uid"),
    };

    try {
      const res =
        await AuthApiServices.resendNewDeviceMobileVerification(values);
      if (res?.data?.status === 1) {
        Toast.success(res?.data?.message);
        localStorage.setItem("hash_key", res?.data.hash_key);
        localStorage.setItem("ownership_uid", res?.data.ownership_uid);
        localStorage.setItem("expiry", res?.data.expiry);
        localStorage.setItem("session_key", res?.data.session_key);
        const expiryTime = getExpiryTime();
        setDuration(moment.duration(expiryTime, "millisecond"));
        setState({ ...state, isResending: false });
        setTargetTime(res?.data.expiry);
      } else {
        Toast.error(res?.data?.message);
        setState({ ...state, isResending: false });
        if (res?.data?.error_code === 5) {
          setState({ ...state, isDisabled: true });
        }
      }

      return res.data ?? "";
    } catch (err) {
      Toast.error(
        "We encountered an issue while processing your login request. Please try again later.",
      );
      console.log("Something went wrong!", err);
    }
  };

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const hasEmptyField = Object.values(inputValues).some(
      (value) => value === "",
    );
    setIsButtonDisabled(hasEmptyField);
  }, [inputValues]);

  return (
    <LayoutWithBackground>
      <SignUpLayout>
        <div className="mobile-verification">
          <Typography
            style={{ marginTop: "20px" }}
            className={classes.signupFormTitle}
          >
            Verify
          </Typography>{" "}
          <div className="text-factor">
            Enter your verification Keyword sent to <br />
            {phone}
          </div>
          <div className="otp">
            <OtpStack
              duration={duration}
              error={error}
              inputValues={inputValues}
              setInputValues={setInputValues}
              setDuration={setDuration}
              fieldIntIndex={""}
              interval={interval}
              setInterval={setInterval}
              targetTime={targetTime}
              isLoading={loading}
            />
          </div>
          {/* <div className="time-verify">
        Your verification Keyword will be valid for 0:59
      </div> */}
          {/* <Button
          variant="outlined"
          className={`add-button font-montserrat-500 ${
            state.isSubmitting ? "button-disabled" : ""
          }`}
          type="submit"
        >
          {state.isSubmitting ? (
            <div className="loader-container">
              <CircularProgress size="20px" />
            </div>
          ) : null}
          <span>Create Task</span>
        </Button> */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <LoadingButton
              sx={{
                "& .MuiLoadingButton-loadingIndicator": { color: "white" },
                width: "250px",
                "&.Mui-disabled": {
                  opacity: 1, // prevent fade-out
                  pointerEvents: "auto", // allow hover/click styles
                  backgroundColor: "primary.main", // keep normal color
                  color: "white", // keep text color
                  cursor: "pointer",
                },
              }}
              className={
                isButtonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              loadingIndicator={
                <AnimatedDots text="Processing" color="white" />
              }
              variant="contained"
              type={"submit"}
              onClick={handleSubmitOTP}
              loading={loading}
              disabled={isButtonDisabled || loading}
            >
              {loading ? "" : "Submit"}
            </LoadingButton>
            <Typography
              style={{ fontSize: "14px", fontWeight: "300" }}
              className={classes.resendEmail}
              component="div"
            >
              <div className="resend-text">
                <div style={{ color: "black" }}>
                  Haven’t received verification Keyword?{""}
                </div>
                <LoadingButton
                  loading={state.isResending}
                  loadingPosition="start"
                  onClick={resendMobileVerification}
                  disabled={state.isDisabled || loading}
                  sx={{
                    padding: "0px",
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 800,
                    width: "50px",
                    top: "-2px",
                    ":hover": {
                      backgroundColor: "none",
                    },
                    "&.Mui-disabled": {
                      color: "grey", // Apply the same style as in the .css rule you mentioned
                    },
                    "&.MuiLoadingButton-root": {
                      minWidth: "fit-content",
                    },
                  }}
                >
                  Resend
                </LoadingButton>
              </div>
            </Typography>
          </Box>
          {/* <p className="this-Keyword">
        <div>How do I get this Keyword?</div>
      </p> */}
          <p className="back-login">
            <Link to={clientRoutes.login}>Back to login page</Link>
          </p>
        </div>
      </SignUpLayout>
    </LayoutWithBackground>
  );
};

export default NewDeviceVerification;
